import React, { Component } from 'react';
import { Form, Button, Table, DatePicker, Select, Tag } from 'antd';
import { ConfigProvider, Icon, Breadcrumb, message, Popover } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { apis } from '../api/index.js';
import moment from 'moment';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import throttle from 'lodash.throttle';
import './Charts.css';
import TableEmpty from '../components/TableEmpty.js';
import { formatDate, getParams, breadBack, changeListWidth } from '../utils';
import { getInstitutionOptions, formatFromTime, formatToTime } from '../utils';
import { institutionRecord } from '../utils';
import { calcTableHeight, showMoreSearch, breadItem } from '../utils';
const { Option } = Select;
//导出excel插件
class ReportWithData extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      total: 0,
      page: 1,
      fromTime: formatDate(new Date(), 'YYYY-MM-DD') + ' 0:0:0',
      toTime: formatDate(new Date(), 'YYYY-MM-DD') + ' 23:59:59',
      institutionId: '',
      loadingIconShow: false,
      institutionData: [],
      i18nextLng: 'zh-CN',
      listWidth: 'calc(87% - 8px)',
      reportList: [], //表格数据
      tableHeight: 0,
      moreFilter: true,
      showMoreFilter: false,
    };

    this.throttledReportstat = throttle(newState => {
      this.reportStat(newState);
    }, 1000);

    this.formResize = throttle(newState => {
      //滚动条重置到顶部
      const newHeight = calcTableHeight(210);
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight || 0 });
    }, 1000);
  }

  componentDidMount() {
    this.throttledReportstat();
    this.getInstitutionData('');
    this.getDoctorList();
    this.getVerifyDoctorList();
    let _this = this;
    window.addEventListener('resize', function() {
      _this.formResize();
    });
    this.formResize();
  }

  componentDidUpdate() {}

  //获取列表
  reportStat = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      startTime: updatedState.fromTime,
      endTime: updatedState.toTime,
      institutionId: updatedState.institutionId,
      pageSize: 20,
      pageNum: updatedState.page,
      verifyUserId: updatedState.verifyUserId,
      reportUserId: updatedState.reportUserId,
    };
    apis.diagStatistics(post).then(result => {
      this.setState({ loadingIconShow: false });
      if (result.code === '0') {
        this.setState({
          reportList: result.data.list,
          total: result.data.total,
        });
      } else {
        message.error(result.message);
        if (result.code === '1009') this.props.history.push('/login');
      }
    });
  };

  //点击搜索按钮
  handleSearch = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        let fromTime = formatFromTime(values.time);
        let toTime = formatToTime(values.time);

        if (!fromTime || !toTime) {
          message.warning('请选择起止时间');
          return;
        }
        const newState = {
          fromTime,
          toTime,
          institutionId: values.name,
          loadingIconShow: true,
          reportUserId: values.reportUserName,
          verifyUserId: values.verifyUserName,
        };

        this.throttledReportstat(newState);
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    this.props.form.resetFields();
    this.setState({ verifyUserId: undefined, reportUserId: undefined });
    this.getInstitutionData();
  };

  //报告医生列表
  getDoctorList = value => {
    apis.reportDoctorList(value).then(res => {
      this.setState({ reportDoctor: res.code === '0' ? res.data : [] });
    });
  };

  //审核医生列表
  getVerifyDoctorList = value => {
    apis.reviewDoctorList(value).then(res => {
      this.setState({ reviewDoctor: res.code === '0' ? res.data : [] });
    });
  };

  //获取机构列表
  getInstitutionData = async name => {
    const data = await institutionRecord(name);
    this.setState({ institutionData: data });
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    this.getInstitutionData(value);
  };

  getColumns = () => {
    const state = window.store.getState();
    const role = state.api.user.info.operationAuths.split(',');
    const more = role.indexOf('M') >= 0 || role.indexOf('T') >= 0;
    const { page } = this.state;
    const columns = [];

    const content = (
      <div className="report-tip-cnt">
        <p>
          <i>严重差错</i>
          --外伤性病变、重大疾病（肿瘤、急危诊）误、漏诊，包括左右定位或部位严重错位；
        </p>
        <p>
          <i>一般性差错</i>
          --主要基本或病变诊断没有误、漏诊，但是次要病变或周围性病变误漏诊，不会造成严重事故或纠纷的差错；
        </p>
        <p>
          <i>用语不当/逻辑差错</i>
          --不遵守影像报告一般规范，报告前后不符合逻辑，报告描述或建议影像影响报告使用人员误解或难理解等等。
        </p>
      </div>
    );

    columns.push(
      {
        title: '序号',
        dataIndex: '',
        key: 'index',
        width: 60,
        render: (text, record, index) => <>{(page - 1) * 20 + index + 1}</>,
        fixed: 'left',
      },
      {
        title: '患者姓名',
        dataIndex: 'patName',
        key: 'patName',
        width: 100,
        render: value => <>{value || '--'}</>,
      },
      {
        title: '影像数量',
        dataIndex: 'diagCount',
        key: 'diagCount',
        width: 100,
        render: value => <>{value || '--'}</>,
      },
      {
        title: '检查部位数',
        dataIndex: 'partCnt',
        key: 'partCnt',
        width: 100,
      },
      {
        title: '检查项目数',
        dataIndex: 'postCnt',
        key: 'postCnt',
        width: 100,
      },
      {
        title: '申请时间',
        dataIndex: 'applicationTime',
        key: 'applicationTime',
        width: 150,
        render: value => <>{value || '--'}</>,
      }
    );
    if (more) {
      columns.push(
        {
          title: '报告医生',
          dataIndex: 'reportUserName',
          key: 'reportUserName',
          width: 100,
          render: value => <>{value || '--'}</>,
        },
        {
          title: '报告状态',
          dataIndex: 'stateName',
          key: 'stateName',
          width: 80,
          render: value => <>{value || '--'}</>,
        },
        {
          title: '报告时间',
          dataIndex: 'reportTime',
          key: 'reportTime',
          width: 150,
          render: value => <>{value || '--'}</>,
        },
        {
          title: '报告时长',
          dataIndex: 'reportDuration',
          key: 'reportDuration',
          width: 80,
          render: value => <>{value || '--'}</>,
        },
        {
          title: '审核医生',
          dataIndex: 'verifyUserName',
          key: 'verifyUserName',
          width: 100,
          render: value => <>{value || '--'}</>,
        },
        {
          title: '审核时间',
          dataIndex: 'verifyTime',
          key: 'verifyTime',
          width: 150,
          render: value => <>{value || '--'}</>,
        },
        {
          title: '审核时长',
          dataIndex: 'verifyDuration',
          key: 'verifyDuration',
          width: 80,
          render: value => <>{value || '--'}</>,
        },
        {
          title: '影像质量评价',
          dataIndex: 'radiographyGrade',
          key: 'radiographyGrade',
          width: 100,
          render: value => <>{value || '--'}</>,
        },
        {
          title: (
            <span>
              诊断报告评价
              <Popover content={content} placement="topLeft">
                <Button type="link" icon="question-circle"></Button>
              </Popover>
            </span>
          ),
          dataIndex: 'diagnosisGrade',
          key: 'diagnosisGrade',
          width: 150,
          render: value => <>{value || '--'}</>,
        },
        {
          title: '报告医生AI评价',
          dataIndex: '',
          key: 'reportAIResult',
          width: 150,
          render: r => (
            <>
              {r.reportAIResult ? (
                <Popover content={r.reportAIDetail || '--'} placement="topLeft">
                  <span>{r.reportAIResult}</span>
                </Popover>
              ) : (
                '--'
              )}
            </>
          ),
        },
        {
          title: '一审医生AI评价',
          dataIndex: '',
          key: 'review1AIResult',
          width: 150,
          render: r => (
            <>
              {r.review1AIResult ? (
                <Popover
                  content={r.review1AIDetail || '--'}
                  placement="topLeft"
                >
                  <span>{r.review1AIResult}</span>
                </Popover>
              ) : (
                '--'
              )}
            </>
          ),
        },
        {
          title: '二审医生AI评价',
          dataIndex: '',
          key: 'review2AIResult',
          width: 150,
          render: r => (
            <>
              {r.review2AIResult ? (
                <Popover
                  content={r.review2AIDetail || '--'}
                  placement="topLeft"
                >
                  <span>{r.review2AIResult}</span>
                </Popover>
              ) : (
                '--'
              )}
            </>
          ),
        },
        {
          title: '送检机构',
          dataIndex: 'institutionName',
          key: 'institutionName',
          width: 150,
          render: value => <>{value || '--'}</>,
        },
        {
          title: 'AI筛查',
          dataIndex: 'nboxAIResult',
          key: 'nboxAIResult',
          width: 100,
          render: value => {
            if (value === '异常') return <Tag color="#FF5605">异常</Tag>;
            else if (value === '正常') return <Tag color="#87D067">正常</Tag>;
            else return value;
          },
        }
      );
    }
    columns.push(
      {
        title: '患者来源',
        dataIndex: 'applyUserName',
        key: 'applyUserName',
        width: 100,
        render: value => <>{value || '--'}</>,
      },
      {
        title: '是否急诊',
        dataIndex: 'emergency',
        key: 'emergency',
        width: 80,
        render: value => <>{value || '--'}</>,
      },
      {
        title: '拒片数量',
        dataIndex: 'refuseDcmCnt',
        key: 'refuseDcmCnt',
        width: 80,
        render: value => <>{value || '--'}</>,
      },
      {
        title: '设备登记号',
        dataIndex: 'accessionNumber',
        key: 'accessionNumber',
        width: 100,
        render: value => <>{value || '--'}</>,
      },
      {
        title: '设备登录流水号',
        dataIndex: 'patId',
        key: 'patId',
        render: value => <>{value || '--'}</>,
      }
    );
    return columns;
  };

  exportDetailExcel = () => {
    let { fromTime, toTime, institutionId } = this.state;
    const { reportUserId, verifyUserId } = this.state;
    const post = {
      startTime: fromTime,
      endTime: toTime,
      institutionId: institutionId,
      reportUserId,
      verifyUserId,
    };
    const search = getParams(post);

    window.location.href = `/ai-web/diagStatistics/exportExcel?${search}`;
  };

  handlePageChange = page => {
    const newState = { page };
    this.throttledReportstat(newState);
  };
  setBackEvent = () => {
    // this.setSearchEvent('ns-066');
  };
  render() {
    let { reportList, institutionData, tableHeight, verifyUserId } = this.state;
    const { moreFilter, showMoreFilter, reportUserId } = this.state;
    const { reportDoctor = [], reviewDoctor = [] } = this.state;

    const { RangePicker } = DatePicker;
    const dateFormat = 'YYYY-MM-DD';

    const columns = this.getColumns();

    const { getFieldDecorator } = this.props.form;
    const institutionOptions = getInstitutionOptions(institutionData, 'id');

    const today = formatDate(new Date(), dateFormat);

    const state = window.store.getState();
    const role = state.api.user.info.operationAuths.split(',');
    const more = role.indexOf('M') >= 0 || role.indexOf('T') >= 0;
    let tableWidth = 1200;
    if (more) tableWidth = 2750;

    return (
      <div className="form-bg">
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={() => changeListWidth(this)}
            login={false}
            home={true}
          />

          <div className="theme-box statistical-report">
            <div className="bread-crumb">
              <Breadcrumb>{breadItem(['统计分析', '远程诊断报告'])}</Breadcrumb>
              {breadBack(this)}
            </div>
            <div className="box" style={{ width: this.state.listWidth }}>
              <div className="left">
                <Form
                  className={`ant-advanced-search-form${
                    !moreFilter && showMoreFilter ? ' notOverflow' : ''
                  }`}
                  onSubmit={this.handleSearch}
                  layout="inline"
                >
                  <div className="searchBox">
                    <div className="searchBoxContent">
                      <Form.Item label="报告医生" colon={false}>
                        {getFieldDecorator('reportUserName', {
                          initialValue: reportUserId,
                        })(
                          <Select
                            showSearch
                            onSearch={this.getDoctorList}
                            allowClear={true}
                            placeholder="选择报告医生"
                            style={{ width: '150px' }}
                            defaultActiveFirstOption={false}
                            filterOption={false}
                          >
                            {reportDoctor.map((item, index) => (
                              <Option value={item.code} key={index}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="审核医生" colon={false}>
                        {getFieldDecorator('verifyUserName', {
                          initialValue: verifyUserId,
                        })(
                          <Select
                            showSearch
                            onSearch={this.getVerifyDoctorList}
                            allowClear={true}
                            placeholder="选择审核医生"
                            filterOption={false}
                            style={{ width: '150px' }}
                          >
                            {reviewDoctor.map((item, index) => (
                              <Option value={item.code} key={index}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="申请时间" colon={false}>
                        <ConfigProvider
                          allowClear={true}
                          locale={
                            this.state.i18nextLng === 'zh-CN' ? zh_CN : null
                          }
                        >
                          {getFieldDecorator('time', {
                            initialValue: [
                              moment(today, dateFormat),
                              moment(today, dateFormat),
                            ],
                          })(
                            <RangePicker
                              format={dateFormat}
                              placeholder={['开始时间', '结束时间']}
                            />
                          )}
                        </ConfigProvider>
                      </Form.Item>
                      <Form.Item label="送检机构" colon={false}>
                        {getFieldDecorator('name', {})(
                          <Select
                            showSearch
                            placeholder="全部"
                            defaultActiveFirstOption={false}
                            showArrow={false}
                            filterOption={false}
                            onSearch={this.handleInstitutionSearch}
                            onChange={this.handleChange}
                            notFoundContent={null}
                            allowClear={true}
                            style={{ width: 240 }}
                          >
                            {institutionOptions}
                          </Select>
                        )}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="searchOptBox">
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn-search"
                      >
                        {this.state.loadingIconShow ? (
                          <Icon type="sync" spin />
                        ) : (
                          <Icon type="search" />
                        )}
                        搜索
                      </Button>
                      <Button
                        icon="redo"
                        style={{ marginLeft: 8 }}
                        className="btn-reset"
                        onClick={this.handleReset}
                      >
                        重置
                      </Button>
                      <Button
                        style={{ marginLeft: 8 }}
                        icon="save"
                        className="btn-reset"
                        disabled={reportList.length === 0}
                        onClick={this.exportDetailExcel}
                      >
                        导出
                      </Button>
                    </Form.Item>
                    {this.state.showMoreFilter ? (
                      <Button
                        type="link"
                        className="moreFilter"
                        onClick={() => {
                          this.setState({ moreFilter: !moreFilter });
                        }}
                        icon={moreFilter ? 'down' : 'up'}
                      >
                        {moreFilter ? '展开' : '收起'}
                      </Button>
                    ) : null}
                  </div>
                </Form>
                <div className="history-list">
                  <Table
                    columns={columns}
                    dataSource={reportList}
                    rowKey={record => record.applicationId}
                    key={record => record.applicationId}
                    className="list-item"
                    scroll={{ x: tableWidth, y: tableHeight }}
                    bordered
                    locale={{ emptyText: <TableEmpty /> }}
                    pagination={{
                      pageSize: 20,
                      size: 'small',
                      showTotal: () => `共${this.state.total}条`,
                      total: this.state.total,
                      onChange: this.handlePageChange,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(ReportWithData));
